module.exports = __webpack_public_path__ + "static/media/lagodigital_8.150f44fc.jpg";